import { render, staticRenderFns } from "./UPRSTRING.vue?vue&type=template&id=679c080f&"
import script from "./UPRSTRING.vue?vue&type=script&lang=js&"
export * from "./UPRSTRING.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports